import { useEffect, useRef, useState } from 'react';
import {
  COOKIE_CONSENT_ACCEPTED,
  COOKIE_CONSENT_REJECTED,
  getCookieConsent,
  loadAnalyticsScripts,
  saveCookieConsent,
} from '../../utils/cookieConsent';

function CookieBanner() {
  const [consent, setConsent] = useState(getCookieConsent);
  const dialogRef = useRef(null);
  const titleRef = useRef(null);

  useEffect(() => {
    if (consent) {
      return;
    }

    const dialog = dialogRef.current;
    const previousOverflow = document.body.style.overflow;

    dialog.showModal();
    titleRef.current.focus();
    document.body.style.overflow = 'hidden';

    return () => {
      dialog.close();
      document.body.style.overflow = previousOverflow;
    };
  }, [consent]);

  useEffect(() => {
    if (consent === COOKIE_CONSENT_ACCEPTED) {
      loadAnalyticsScripts();
    }
  }, [consent]);

  const handleConsentChoice = (choice) => {
    setConsent(saveCookieConsent(choice));
  };

  if (consent) {
    return null;
  }

  return (
    <dialog
      ref={dialogRef}
      className="cookie-banner"
      aria-modal="true"
      aria-labelledby="cookie-banner-title"
      aria-describedby="cookie-banner-description"
      onCancel={(event) => event.preventDefault()}
    >
      <p className="cookie-banner-brand">Fes-me l’acta!</p>
      <h2 id="cookie-banner-title" className="cookie-banner-title" ref={titleRef} tabIndex={-1}>
        Cookies i privacitat
      </h2>
      <p id="cookie-banner-description" className="cookie-banner-text">
        Fem servir cookies tècniques perquè el servei funcioni. Amb el teu permís, també farem
        servir cookies analítiques per entendre com s’utilitza el web i millorar-lo. Pots
        rebutjar les opcionals sense perdre les funcions bàsiques.
      </p>
      <a className="cookie-banner-privacy" href="/privacy">
        Més informació a la política de privacitat
        <span aria-hidden="true">›</span>
      </a>
      <div className="cookie-banner-actions">
        <button
          type="button"
          className="cookie-banner-button secondary"
          onClick={() => handleConsentChoice(COOKIE_CONSENT_REJECTED)}
        >
          Rebutjar opcionals
        </button>
        <button
          type="button"
          className="cookie-banner-button primary"
          onClick={() => handleConsentChoice(COOKIE_CONSENT_ACCEPTED)}
        >
          Acceptar opcionals
        </button>
      </div>
    </dialog>
  );
}

export default CookieBanner;
